//
// Slick carousel - Service
// --------------------------------------------------

$('.trw-carousel-service').slick({
    nextArrow: '<button type="button" class="slick-next"><i class="far fa-angle-right" data-fa-transform="shrink-6"></i></button>',
    prevArrow: '<button type="button" class="slick-prev"><i class="far fa-angle-left" data-fa-transform="shrink-6"></i></button>',
    dots: true,
    adaptiveHeight: true,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },{
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});


// WEBPACK FOOTER //
// ./Private/JavaScript/Component/CarouselService.js